import { Capacitor } from "@capacitor/core";
import { useEffect, useMemo, useState } from "react";

const maxWidthForMobilePx = 768;

export function isNativeIos(): boolean {
    return Capacitor.getPlatform() === "ios";
}

export function isNativeMobile(): boolean {
    return ["android", "ios"].includes(Capacitor.getPlatform());
}

export function isMobileView(): boolean {
    // This function can be a lit misleading since an android view can be also a tablet view with more than 768px of width.
    // For the time being, I think it's good enough
    return isNativeMobile() || window.innerWidth <= maxWidthForMobilePx;
}

export function useIsMobileView(): [boolean] {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const isMobileView = useMemo(() => windowWidth <= maxWidthForMobilePx, [windowWidth]);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return [isMobileView];
}